module.exports = __webpack_public_path__ + "img/invalid-sign.abfeb045.png";